import Icon from '@material-ui/icons/ListAltRounded';
import List from './LogList';

export default {
    list: List,
    icon: Icon,
};